import React from "react";
import clsx from "clsx";

import { ReactComponent as SettingIcon } from "../../../../assets/svg/setting.svg";
import { ILesson } from "../../../../state";
import styles from "../SelectPage.module.scss";

interface IPublishControlsProps {
  activeLesson: ILesson;
  calling: boolean;
  onPublishLesson: (lesson_id: number) => void;
  onUnPublishLesson: (lesson_id: number) => void;
  onOpenSettingModal: () => void;
}

const PublishControls = ({
  activeLesson,
  calling,
  onPublishLesson,
  onUnPublishLesson,
  onOpenSettingModal,
}: IPublishControlsProps) => {
  return (
    <div className={styles.publishControls}>
      <button
        className={clsx(
          styles.publishBtn,
          activeLesson.published && styles.active,
        )}
        onClick={() => {
          if (!activeLesson.published) {
            onPublishLesson(activeLesson.id);
          }
        }}
        disabled={calling}
      >
        生徒に公開する
      </button>
      <button
        className={clsx(
          styles.unpublishBtn,
          !activeLesson.published && styles.active,
        )}
        onClick={() => {
          if (activeLesson.published) {
            onUnPublishLesson(activeLesson.id);
          }
        }}
        disabled={calling}
      >
        公開しない
      </button>
      <button
        className={styles.settingBtn}
        disabled={calling}
        onClick={onOpenSettingModal}
      >
        <SettingIcon />
      </button>
    </div>
  );
};

export default PublishControls;
